angular.module('mtic.components.modules.c3').
directive('c3ModuleSelect', function (
  $log,
  $timeout,
  TIMING_CONSTANTS,
  EventManager,
  C3_META_ASSET_URL,
  PIXI,
  language,
  MODULE_AVAILABLE_LANGUAGE,
  MapStateService,
  userAccount,
  preliveCheck,
  DEV_VARIABLES,
  TeacherDataService,
  LocaleService,
  PanelStateService,
  PlatformService,
  ModuleFilter
) {

  return {
    templateUrl: 'template.html',//<canvas id="canvas" width="300" height="300"></canvas>',
    scope: {
      moduleMapData: "=moduleMapData",
      interceptClick: "=?",
      workspaceData:"=?"
    },
    link: function (scope) {
      scope.badBrowser = false;
      scope.isTeacher = userAccount.getData().role.isTeacher;
      scope.isTeacherWorkspaceView = TeacherDataService.isTeacherWorkspaceView;
      scope.getTranslation = function(slug){
        return language.get(slug);
      }
      /*
      if(window.isWebEmbedConnect && !scope.interceptClick && !navigator.userAgent.match(/Android/i)){
        //kickout to browser
        var userData = userAccount.getData();
        var cur_class = userAccount.getData().role.isTeacher ? scope.moduleMapData.class_id : userAccount.getActiveClassroom();
        window.location.href = 'https://mathematic.lu/app2/'+'?web-open-browser&firebase_token='+userData.firebase_token+'&uuid='+userData.uuid+'&session_key='+userData.sessionKey+'&user_id='+userData.user_id+'&class_id='+cur_class;//window.location.href.replace('/?debugBrowsers#/web-embed-connect', '').replace('web-embed-connect', '').replace('web-embed-response', '').replace('&iam-logout', '')
      }
      */
      // else if(window.isWebEmbedConnect && !scope.interceptClick){
      //   scope.badBrowser = true;
      // }
     // $timeout(() => {
        var eventManager = new EventManager('c3ModuleSelect', scope);
        var planetContainer;
        var canvas_el;
        var scale = 1;
        var canvasDimension;var sBackground;var sBlackScreen;var sShip;var sStars;var container;var Planets;var app;        scope.currentActiveSubModule = null;
        var androidAdjustmentX = 0;
        var androidAdjustmentY = 0;
        var update_text; var update_direction = 0.002;

        scope.goBackToClasses = function(){
          eventManager.broadcast("navbar:my-classes:click");
          eventManager.broadcast('module:close:resource');
        }
        scope.hasModuleOption = function(){
          return true && scope.currentActiveSubModule && scope.currentActiveSubModule.children;
        }
        var onResize = function(sidepanel_expanded) {
          if(!canvas_el){
            return;
          }
          var sidepanel_width = TeacherDataService.sidepanelStatus ? 260:60;
          var canv_width;
          if(!TeacherDataService.isTeacherWorkspaceView && !TeacherDataService.inTeacherAgendaView){
            if(sidepanel_expanded === true || sidepanel_expanded === false){
              sidepanel_width = sidepanel_expanded ? 140 : -200;
            }else{
              sidepanel_width = 0;
            }
            canv_width =  canvas_el.parentElement.offsetWidth - sidepanel_width;
          }else{
            var middleview = document.getElementById('agenda_middleview');
            if(middleview){
              sidepanel_width += 300
            }
            if(!TeacherDataService.inTeacherAgendaView){
              sidepanel_width += -30;
            }
            canv_width = window.innerWidth - 370 - sidepanel_width;
          }
         canvasDimension = {
            width: canv_width,
            height: window.innerHeight - 35
          }

          canvas_el.width = canvasDimension.width;
          canvas_el.height = canvasDimension.height;
          sBackground.width = canvasDimension.width;
          sBackground.height = canvasDimension.height;

          var min_w = 1200;
          var min_h = 600;

          scale = Math.min(canvasDimension.width / min_w, canvasDimension.height / min_h);


          planetContainer.scale.set(Math.min(scale, 1));

          var offset = TeacherDataService.inTeacherAgendaView || TeacherDataService.isTeacherWorkspaceView? -20 : 50;//scope.isTeacher ? 250 : 75
          planetContainer.x = canvasDimension.width / 2 -planetContainer.width / 2 - offset;

          // if(TeacherDataService.isTeacherWorkspaceView){
          //   if(window.screen.width < 1200){
          //     planetContainer.x += 75;
          //     planetContainer.scale.set(Math.min(0.5, scale, 1))
          //   }else{
          //     planetContainer.scale.set(Math.min(0.8, scale, 1))
          //   }
          // }
          planetContainer.y = canvasDimension.height / 2 -planetContainer.height / 2;

          sShip.y = canvasDimension.height - 150;

          sStars.width = canvasDimension.width;
          sStars.height = canvasDimension.height;
          app.resize(canvasDimension.width, canvasDimension.height);
        };

        // Initialize everything
        //Initialize();

        var isMobile = (navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent));
        scope.$watch('moduleMapData', function(moduleMapData){
          if (!moduleMapData || EXISTS) {
            return;
          }
          $timeout(()=>{
            Initialize()
            setSubmodule(MapStateService.getActiveModule());
            //var expanded = TeacherDataService.inTeacherAgendaView || isMobile ? false : null;
            EXISTS = true;
          })
          var timer = isMobile ? 1200 : 500;
          $timeout(()=>{
            //var expanded = isMobile && scope.isTeacher ? false : null;
            onResize();
            scope.loading_done = true;
          }, timer)

        })

        eventManager.listen('module:change:submodule', function(e, slug) {
          // $log.log('module:change:submodule : ' , slug)
          if(MODULE_AVAILABLE_LANGUAGE[slug]){
            language.setAvailableOptions(MODULE_AVAILABLE_LANGUAGE[slug])
          }
          var resources = scope.moduleMapData.resources;
          for (var i = 0; i < resources.length; i ++){
            var resource = resources[i];
            if (slug === resource.slug){
              language.setAvailableOptions( _.get(resource, ['content', 'available_languages', LocaleService.getUrlVersion() ] ) );
              break;
            }
          }

        });
        eventManager.listen('module:change:meta', function(e, slug) {
          language.resetAvilableOptions();
          if(MODULE_AVAILABLE_LANGUAGE[slug]){
            language.setAvailableOptions(MODULE_AVAILABLE_LANGUAGE[slug])
          }
          if (MapStateService.getActiveModule() === 'run_like_math'){
            MapStateService.setActiveModule(scope.moduleMapData.slug);
            eventManager.broadcast('module:close:resource', {isPassive:true});
          }
          //scope.currentActiveSubModule = null;
          $timeout(function(){
            onResize();
          }, 100);
        });

        var assignMatchedSlug = function(matchedSlug,resource){
          $timeout(function(){
            scope.interceptClick.slug = matchedSlug;
            if(matchedSlug==="run_like_math"){
              eventManager.broadcast("module:change:run_like_math",resource);
            }
          },100);
        }

        var lastSlug
        var setSubmodule = function(slug){
          if(slug === 'run_like_math' && TeacherDataService.inTeacherAgendaView){
            return;
          }
          var i;
          if(scope.interceptClick){
            if(scope.interceptClick.slug !== slug){
              for (i = 0; i < scope.moduleMapData.resources.length; i ++){
                if (slug === scope.moduleMapData.resources[i].slug){
                  var matchedSlug = scope.moduleMapData.resources[i].slug;
                  assignMatchedSlug(matchedSlug,scope.moduleMapData.resources[i]);
                  //scope.$apply();
                }
              }
            }else{
              eventManager.broadcast('retrigger-workspace-filters', scope.interceptClick.slug);
            }

            if(TeacherDataService.inTeacherAgendaView && !scope.interceptClick.slug && slug){
              $timeout(function(){
                //eventManager.broadcast('retrigger-workspace-filters', scope.interceptClick.slug);
              }, 200)
            }

          // $log.log('interceptClick : ' , scope.interceptClick.slug, slug)
            return;
          }
          if (DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(slug) > -1) {
            if (!preliveCheck.isPreliveCheck() && !preliveCheck.isQCCheck()){
              if (lastSlug !== slug){
                window.alert(language.get('module_is_locked'))
                return;
              }
            }
          }
          for (i = 0; i < scope.moduleMapData.resources.length; i ++){
            if (slug === scope.moduleMapData.resources[i].slug){
              scope.currentActiveSubModule = scope.moduleMapData.resources[i];
              scope.currentActiveSubModule.resources = scope.currentActiveSubModule.children;
              eventManager.broadcast('module:change:submodule', scope.currentActiveSubModule.slug);
              eventManager.broadcast('submodule:opened', {
                slug: scope.currentActiveSubModule.slug,//module_container.slug,
                name: scope.currentActiveSubModule.name
              });
              MapStateService.setActiveModule(slug);
              break;
            }
          }
          lastSlug = slug;
        }


        var drag_info = {};
        var _TOUCHED_POINTS = []
        var Initialize = function()
        {
          PIXI.ticker.shared.add(delta_resize);
          // PIXI.ticker.shared.add(update);
          canvas_el = document.getElementById('c3-map-canvas');
          canvasDimension = {
            width: 500,
            height: 500
          }
          $timeout(function(){
            if(canvas_el){
              canvas_el.addEventListener('DOMMouseScroll', handleScroll, false); // for Firefox
              canvas_el.addEventListener('mousewheel', handleScroll, false); // for everyone else
            }
          }, 1000)


          MapStateService.setMetaStateSlug('mtic_c3_m_meta')
          // Load Assets
          sBackground = new PIXI.Sprite(PIXI.Texture.fromImage(C3_META_ASSET_URL + 'bkg.png'));
          sBlackScreen = new PIXI.Sprite(PIXI.Texture.fromImage(C3_META_ASSET_URL + 'blackscreen.png'));
          sShip = new PIXI.Sprite(PIXI.Texture.fromImage(C3_META_ASSET_URL + 'spaceship.png'));
          sStars = new PIXI.extras.TilingSprite(PIXI.Texture.fromImage(C3_META_ASSET_URL + 'star_pattern.png'));

          container = new PIXI.Container();
          planetContainer = new PIXI.Container();
          Planets = [];

          var PlanetSprites = new Array(
            new PIXI.Sprite.fromImage(C3_META_ASSET_URL + 'planet_spces.png'),
            new PIXI.Sprite.fromImage(C3_META_ASSET_URL + 'planet_measuremtent.png'),
            new PIXI.Sprite.fromImage(C3_META_ASSET_URL + 'planet_numbers.png'),
            new PIXI.Sprite.fromImage(C3_META_ASSET_URL + 'planet_problem.png'),
            new PIXI.Sprite.fromImage(C3_META_ASSET_URL + 'planet_problem.png'),
            new PIXI.Sprite.fromImage(C3_META_ASSET_URL + 'planet_operations.png')
          );


          // Create the application and container
          var isAndroid = navigator.userAgent.match(/Android/i);
          if(isAndroid){
            app = new PIXI.CanvasRenderer(1200,600,{
              autoResize: true,
              backgroundColor: 0x000000,
              view: canvas_el
            });
          }else{
            app = PIXI.autoDetectRenderer(256, 256, {
              autoResize: true,
              backgroundColor: 0x000000,
              view: canvas_el
            });
          }

          // Add background
          container.addChild(sBackground);
          container.addChild(sStars);

          // Add Space Ship
          sShip.x = -50;
          sShip.y = 450;
          container.addChild(sShip);

          // Define the Planet Array

          var startX = 0,startY=0;
          if(TeacherDataService.isTeacherWorkspaceView){
            startX = -200;
            startY = 5;
          }

          if(isAndroid){
            androidAdjustmentX = 50;
            androidAdjustmentY = 50;
          }

          Planets = new Array(
          new Planet(PlanetSprites[0],startX+ 220+androidAdjustmentX, startY+100+androidAdjustmentY, -3, 0,"mtic_c3_m56"),
         // new Planet(PlanetSprites[1], 680, 100, 15, -20, 5.0, 10.0, 0xFFCC00,  "Planet\nZone"),
          new Planet(PlanetSprites[2],startX+ 450+androidAdjustmentX, startY+300-androidAdjustmentY, 12, 0, "mtic_c3_m3"),
          new Planet(PlanetSprites[3],startX+ 1000, startY+300-androidAdjustmentY, 0, 0, "mtic_c3_m1"),
          new Planet(PlanetSprites[4],startX+ 1000, startY+300-androidAdjustmentY, 0, 0, "mtic_c3_m1v2"),
          new Planet(PlanetSprites[5],startX+ 720+(androidAdjustmentX/2), startY+400-androidAdjustmentY-androidAdjustmentY, 0, 0,"run_like_math")
          );

          container.addChild(planetContainer);
          container.on('pointerdown', function(e) {
            var e_o = e.data.originalEvent;
            _TOUCHED_POINTS.push({ pointer_id: e_o.pointerId, x:e_o.pageX, y:e_o.pageY});
            drag_info.dragging = true;
            //focus_item = null;

            drag_info.velocity = {
              x: 0,
              y: 0
            };
            drag_info.start_drag_pos = {
              x: planetContainer.x,
              y: planetContainer.y
            };
            // drag_info.start_drag_pos_meta = {
            //   x: meta_container.x,
            //   y: meta_container.y
            // };
            drag_info.start_drag_mouse_pos = {
              x: e.data.global.x,
              y: e.data.global.y
            };
            drag_info.last_mouse_pos = {
              x: drag_info.start_drag_mouse_pos.x,
              y: drag_info.start_drag_mouse_pos.y
            };

          });
          container.on('pointerup', function(e) {
            if (window.DEBUG_TOUCH){ $log.log('c3_module pointerup ; ', JSON.stringify(e)); }
            drag_info.dragging = false;
            var e_o = e.data.originalEvent;
            var index = _TOUCHED_POINTS.findIndex(function(point, index) {
              if(point.pointer_id === e.pointerId){
                return true;
              }
            });
            _TOUCHED_POINTS.splice(index, 1);
          });
          container.on('pointerout', function(e) {
            drag_info.dragging = false;
            var e_o = e.data.originalEvent;
            var index = _TOUCHED_POINTS.findIndex(function(point, index) {
              if(point.pointer_id === e.pointerId){
                return true;
              }
            });
            _TOUCHED_POINTS.splice(index, 1);
          });
          container.interactive = true;
          // container.scale.set(0.5,0.5);

          if (window.DEBUG_TOUCH){ $log.log('c3_module pointerdown ; ', JSON.stringify(drag_info)); }
        }

        //onResize();
        // Update Function
        function update(){
          if (drag_info.dragging && _TOUCHED_POINTS.length < 2) {
            var mouse_pos = {
              x: app.plugins.interaction.eventData.data.global.x,
              y: app.plugins.interaction.eventData.data.global.y
            }


            // $log.log('DRAGGING :  ', mouse_pos.x, mouse_pos.y)
            if (isNaN(mouse_pos.x) || isNaN(mouse_pos.y) || (isMobile && app.plugins.interaction.eventData.data.identifier === 'MOUSE')){
              mouse_pos.x = drag_info.last_mouse_pos.x;
              mouse_pos.y = drag_info.last_mouse_pos.y;
            }

            // if(!scope.currentActiveSubModule || Object.keys(scope.currentActiveSubModule).length === 0){
            //   meta_container.position.x = drag_info.start_drag_pos_meta.x - (drag_info.start_drag_mouse_pos.x - mouse_pos.x);
            //   meta_container.position.y = drag_info.start_drag_pos_meta.y - (drag_info.start_drag_mouse_pos.y - mouse_pos.y);
            // }else{
            //   //Move the map based on the mouse position
              planetContainer.x = drag_info.start_drag_pos.x - (drag_info.start_drag_mouse_pos.x - mouse_pos.x);
              planetContainer.y = drag_info.start_drag_pos.y - (drag_info.start_drag_mouse_pos.y - mouse_pos.y);
            // }

            //vector of mouse movement since last update frame
            var delta_pos = {
              x: drag_info.last_mouse_pos.x - mouse_pos.x,
              y: drag_info.last_mouse_pos.y - mouse_pos.y
            };

            //add the mouse movement vector to the map movement velocity (inertia)
            drag_info.velocity = {
              x: (drag_info.velocity.x * 4 + delta_pos.x) / 5,
              y: (drag_info.velocity.y * 4 + delta_pos.y) / 5
            };

            //store the current position in the last_mouse_pos to calculate the movement vector next frame
            drag_info.last_mouse_pos = {
              x: mouse_pos.x,
              y: mouse_pos.y
            };

            if (window.DEBUG_TOUCH){ $log.log('c3_module update ; ', JSON.stringify(drag_info)); }

          }
        }

        function delta_resize(delta)
        {
          // Update things here

          if (canvasDimension.width !== window.innerWidth || canvasDimension.height !== window.innerHeight - 52){
            //onResize();
          }
          if(update_text){
            update_direction = update_text.scale.x >= 1.1 ||  update_text.scale.x < 1 ? update_direction * -1 : update_direction;
            update_text.scale.x += update_direction;
            update_text.scale.y += update_direction;
            update_text.alpha = 1 - 2.5*(1.1 - update_text.scale.x);

            update_text.x += update_direction * -1;
          }

          app.render(container);
        }

        eventManager.listen('module:change:meta', function(data){
          scope.currentActiveSubModule = null;
        });

        var computeModuleScoreRecursive = function(resource)
        {
          var scoreInfo = {
            score: 0,
            scoreMax: 0
          }
          for (var n = 0; n < resource.children.length; n ++){
            var subResource = resource.children[n];
            if (subResource.children && subResource.score === undefined){
              var subScoreInfo = computeModuleScoreRecursive(subResource);
              // $log.log('[[planet slug]] UPDATE subScoreInfo', subScoreInfo, subResource.score / subResource.scoreMax)
              if (subScoreInfo.scoreMax > 0){
                scoreInfo.scoreMax ++;
                scoreInfo.score += subScoreInfo.score / subScoreInfo.scoreMax;
              }
            }
            else{
              scoreInfo.scoreMax ++;
              if(workspace_data){
                scoreInfo.score += workspace_list[subResource.id] ? 1 : 0;
              }else{
                scoreInfo.score += subResource.complete ? 1 : 0;
              }
            }
          }
          // $log.log('[[planet slug]] COMPLETE', scoreInfo);
          return scoreInfo;
        }

        // Define Planet Object
        var Planet = function(sprite, xPos, yPos, xTxtOffset, yTxtOffset, slug)
        {

          this.score = 0;
          this.scoreMax = 0;

          // $log.log('[[planet slug]] PRE', slug);
          var module_resource;
          for (var i = 0; i < scope.moduleMapData.resources.length; i ++){
            if (slug === scope.moduleMapData.resources[i].slug){
              module_resource = scope.moduleMapData.resources[i];
              var scoreInfo = computeModuleScoreRecursive(scope.moduleMapData.resources[i]);
              this.score = scoreInfo.score;
              this.scoreMax = scoreInfo.scoreMax;
            }
          }

          if(!module_resource || (module_resource && !ModuleFilter.checkAvailable(module_resource))){
            return;
          }

          this.scoreCompletion = this.score / this.scoreMax;
          this.xPos = xPos;
          this.yPos = yPos;

          // $log.log('[[planet slug]] POST', slug, this.scoreCompletion);
          var graphics = new PIXI.Graphics();

          // Sprite
          this.sprite = sprite;
          this.sprite.x = this.xPos;
          this.sprite.y = this.yPos;
          this.sprite.interactive = true;
          this.sprite.buttonMode = true;
          sprite.anchor.set(0.5, 1);

          this.sprite.slug = slug;
          this.sprite.on('pointertap', function(e){
            var cur_slug = e.currentTarget.slug;
            if (e.data.originalEvent.target && e.data.originalEvent.target.id !== 'c3-map-canvas') {
              return;
            }
            if((cur_slug === 'mtic_c3_m1' || cur_slug === 'mtic_c3_m3') && (navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1)){
              window.alert('Some of the video items are currently not supported on Internet Explorer. Please use a different browser for the best results.')
            }
            if(cur_slug === 'mtic_c3_m56' &&
              isMobile &&
              !window.confirm('This module is not optimized for mobile devices. Please use a different device for the best results.')){
                return;
            }
            if(cur_slug === 'mtic_c3_m56' && (navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1)) {
              window.alert('This module is currently not supported on Internet Explorer. Please use a different browser to access this module.');
              return;
            }
            $timeout(function(){
              if(!zooming){
                setSubmodule(cur_slug);
              }
            }, 10)
          });

           var setupText = () => {
            // Text Information
            graphics.removeChildren();
            graphics.clear();

            var textInfo = new PIXI.Text(language.get(slug));
            textInfo.style.align = "center";
            textInfo.style.fill = "white";
            textInfo.style.fontFamily = "Helvetica";
            textInfo.style.fontSize = isMobile ? 22: 15;


            graphics.position.set(xPos - textInfo.width, yPos + 10);

            var new_module = module_resource.slug === 'mtic_c3_m1v2';
            var height_diff = new_module ? 40 : 0

            textInfo.x = ((textInfo.width / 2)) + xTxtOffset;
            textInfo.y = (20 - textInfo.height / 2) + 10 + yTxtOffset;

            // Draw Text Bubble that wraps around the text
            graphics.lineStyle(0);
            graphics.beginFill(0x3B5763);
            graphics.drawRoundedRect(textInfo.x - 20, textInfo.y - 10, textInfo.width + 40, textInfo.height + 40 + height_diff, 10);
            graphics.endFill();
            if(new_module){
              graphics.lineStyle(0);
              graphics.beginFill(0x33ccff);
              graphics.drawRoundedRect(textInfo.x - 20, textInfo.y - 10, textInfo.width + 40, 40, 10);
              graphics.drawRect(textInfo.x - 20, textInfo.y + 10, textInfo.width + 40, 20);
              graphics.endFill();

              update_text = new PIXI.Text(language.get('updated_slug'));
              update_text.anchor.set(0.5);
              update_text.style.align = "center";
              update_text.style.fill = "white";
              update_text.style.fontFamily = "Helvetica";
              update_text.style.fontSize = 18;
              update_text.x = (textInfo.x - 20) + (textInfo.width + 40)/2;
              update_text.y = 33 + yTxtOffset;
              graphics.addChild(update_text);
            }

            // Draw Triangle pointing to planet
            graphics.beginFill(new_module ? 0x33ccff : 0x3B5763);
            graphics.moveTo(textInfo.x + (textInfo.width / 2) - 5, textInfo.y - 10);
            graphics.lineTo(textInfo.x + (textInfo.width / 2), textInfo.y - 18);
            graphics.lineTo(textInfo.x + (textInfo.width / 2) + 5, textInfo.y - 10);
            graphics.lineTo(textInfo.x + (textInfo.width / 2) - 5, textInfo.y - 10);
            graphics.endFill();

            // Draw the score bar
            graphics.beginFill(0x3CE4B7);
            graphics.drawRect(textInfo.x - 10, textInfo.y + textInfo.height + 10 + height_diff, (textInfo.width + 20) * this.scoreCompletion, 10);
            graphics.endFill();

            // Draw the score bar background (What isn't completed yet)
            graphics.beginFill(0x4B6875);
            graphics.drawRect(textInfo.x - 10 + ((textInfo.width + 20) * this.scoreCompletion), textInfo.y + textInfo.height + 10 + height_diff, (textInfo.width + 20) - ((textInfo.width + 20) * this.scoreCompletion), 10);
            graphics.endFill();
            graphics.addChild(textInfo);

            textInfo.y += height_diff;
          }
          this.setupText = setupText;
          this.setupText();


          eventManager.listen('language:change', function() {
            setupText();
          });
          // Add everything to the stage
          planetContainer.addChild(graphics);
          planetContainer.addChild(this.sprite);
        }

        scope.$on('$destroy', function() {
          destroy_c3();
        });

        scope.returnToMetaModules = function() {
          eventManager.broadcast('module:change:meta', 'mtic_c3_m_meta');
        }


      scope.getLang = language.get;

      var workspace_list = {};
      var users_list = [];
      var workspace_data;
      scope.$watch('[workspaceData.users, workspaceData.modules]', function(val){
        // $log.log('workspace change ', val)
        $timeout(function(){
          workspace_data = true;
          if(Planets && scope.workspaceData && val && val.length > 0 && scope.workspaceData.modules.length > 0 && (!scope.currentActiveSubModule || !scope.currentActiveSubModule.children)){
            workspace_list = {};
            users_list = [];
            scope.workspaceData.users.forEach( function(user){
              users_list.push(user.user_id);
            })

            scope.workspaceData.modules.forEach( function(work){
              if(users_list.indexOf(work.user_id) > -1){
                workspace_list[work.resource_id] = scope.workspaceData.users.length === 1 && (work.completed || workspace_list[work.resource_id]) ? true : false;
              }
            })

            Planets.forEach(function(planet){
              for (var i = 0; i < scope.moduleMapData.resources.length; i ++){
                if (planet.sprite && planet.sprite.slug === scope.moduleMapData.resources[i].slug){
                  // for(var j = 0; j < scope.moduleMapData.resources[i].children.length ; j++){
                  //   var sub = scope.moduleMapData.resources[i].children[j];
                  //   if(sub.complete && !workspace_list[sub.id]){
                  //     sub.complete = false;
                  //   }
                  // }
                  var scoreInfo = computeModuleScoreRecursive(scope.moduleMapData.resources[i], workspace_list);

                  // $log.log('scoring : ' , scoreInfo, scope.moduleMapData.resources[i])
                  planet.score = scoreInfo.score;
                  planet.scoreMax = scoreInfo.scoreMax;
                }
              }

              planet.scoreCompletion = planet.score / planet.scoreMax;
              if(planet.setupText){
                planet.setupText()
              }
            })


          workspace_data = false;
          }
        },50)
      })

      eventManager.listen('module:select:resource', function(e, data) {
        var scopeResource = getResourceBySlug(data.slug);
        // $log.log('meta got event module:select:resource ', data, scopeResource)
        if (scopeResource === null || data.dontCont){
          eventManager.broadcast('module:dismiss:focus')
          return;
        }
        //Find the module that contains the selected item and open it
        var found;
        for (var i = 0; i < scope.moduleMapData.resources.length; i++)
        {
          if(data.slug === 'run_like_math' && scope.moduleMapData.resources[i].slug === data.slug){
            found = data.slug;
            break;
          }
          if (scope.moduleMapData.resources[i].children.indexOf(scopeResource) > -1 )
          {
            if (MapStateService.getActiveModule() !== scope.moduleMapData.resources[i].slug)
            {
              found = scope.moduleMapData.resources[i].slug;
              // $timeout(function(){
              //   setSubmodule(scope.moduleMapData.resources[i].slug);
              // }, 1000);
              data.dontCont = true;
              break;
            }
          }
        }
        if(found){
          scope.currentActiveSubModule = null;
          $timeout(function(){
            setSubmodule(found);
          }, 150);
        }

        // $timeout(()=>{
        //   eventManager.broadcast('module:select:resource', data)
        // }, 500);

      })
      var getResourceBySlug = function(slug)
      {
        var i, n;
        for (n = 0; n < scope.moduleMapData.resources.length; n ++)
        {
          if(scope.moduleMapData.resources[n].slug === slug){
            return scope.moduleMapData.resources[n];
          }
          for (i = 0; i < scope.moduleMapData.resources[n].children.length; i++)
          {
            if (scope.moduleMapData.resources[n].children[i].slug === slug)
            {
              return scope.moduleMapData.resources[n].children[i];
            }
          }
        }
        return null;
      }
      var prehighlighted_list = [];
      eventManager.listen('highlight:map:items', function(e,list){
        // $log.log('got prehighlighted list : ', list)
        prehighlighted_list = list;
      });


      eventManager.listen('sidepanel:toggled', function(e, val){
        if(!PlatformService.isPhonePortrait()){
          onResize(val);
        }
      })

      scope.view_controller = {
        isStudentView: true,
        isModulePanelView: true,
        openSubMod: function(slug){
          // $log.log('opening sub mod:', slug)
          $timeout(function(){
            eventManager.broadcast('module:change:submodule', slug);
          }, 1000)
        },
        openMainMod: function(slug){
          eventManager.broadcast('module:change:meta', 'mtic_c3_m_meta');
        }
      }

      var zooming = false;
      scope.zoom_function = function(val){
        handleScroll({detail: val, preventDefault: ()=>{}})
        zooming = true;
        $timeout(function(){
          zooming = false
        }, 10)
      }
      var handleScroll = function(evt) {
        if (!evt) {
          return;
        }
        //normalize the wheel delta because browsers send all sorts of values
        var direction = (evt.detail < 0 || evt.wheelDelta > 0) ? 1 : -1;

        //store the current scale so we can calculate the difference
        var start_scale = scale;
        scale = Math.max(Math.min(1.0, scale + direction / 15), 0.25);
        var diff = scale - start_scale;

        planetContainer.scale.set(scale, scale);

        evt.preventDefault();
        return false;
      };

      scope.selectAgendaPanel = function(){
        if (!scope.showAgenda){
          scope.showAgenda = true;
          PanelStateService.setAgendaShowing(scope.showAgenda);
          eventManager.broadcast('moduleview:agenda:request');
        }
      }

      scope.selectModulePanel = function(){
        if (scope.showAgenda){
          scope.showAgenda = false;
          PanelStateService.setAgendaShowing(scope.showAgenda);
          // for (var i = 0; i < items.length; i++) {
          //   items[i].undoAgendaHighlight();
          // }
        }
      }

      scope.dotifyUnitName = function dotifyUnitName() {
        let overviewDays = document.querySelector(".studentSidebarAgendaUnit__overviewDays");
        let unitNames = document.querySelectorAll(".studentSidebarAgendaUnit__name");

        if (!overviewDays || !unitNames) {
          return;
        }

        let overviewDaysWidth = overviewDays.clientWidth;

        for (let i=0; i < unitNames.length; i++) {
          if (unitNames[i].clientHeight >= unitNames[i].scrollHeight) {
            unitNames[i].style.overflow = 'hidden';
            unitNames[i].style.textOverflow = 'ellipsis';
            unitNames[i].style.width = unitNames[i].clientWidth - overviewDaysWidth + "px";

            continue;
          }
          var limit = unitNames[i].offsetTop + unitNames[i].offsetHeight;
          var dots = document.createElement('span');
          if (unitNames[i]['data-inner']) {
            unitNames[i].innerHTML = unitNames[i]['data-inner'];
          } else {
            unitNames[i]['data-inner'] = unitNames[i].innerHTML;
          }
          dots.appendChild(document.createTextNode('...'));
          unitNames[i].style.overflow = 'hidden';
          unitNames[i].appendChild(dots);
          while (dots.offsetTop + dots.offsetHeight > limit) {
            dots.previousSibling.data = dots.previousSibling.data.replace(/\W*\w+\W*$/, '')
          }
        }
      }

      scope.agendas_list = [];
      eventManager.listen('moduleview:agenda:loaded', function(e, data){
        if (data.length > 0)
        {
          scope.hasAgendas = true;
          scope.agendas_list = data;
          scope.selectAgendaPanel();
          // data.forEach(function(agenda){
          //   if(agenda.force_unlock){
          //     agenda.resources.forEach(function(item){
          //       unlockpath(item);
          //     })
          //   }
          // })

          angular.element(document).ready(function() {
            $timeout(function() {
              scope.dotifyUnitName();
            }, 100);
          });
        } else {
          scope.hasAgendas = false;
          scope.selectModulePanel();
        }
      });

      eventManager.listen('offline-post-call-resolved', function(){
        if(!scope.currentActiveSubModule){
          destroy_c3(true);
          eventManager.broadcast('refresh:current:tab');
          eventManager.broadcast('student:cycle:open');
        }
      });

      function destroy_c3(clear_cache){
        EXISTS = false;
        canvas_el = document.getElementById('c3-map-canvas');
        if(canvas_el){
          canvas_el.removeEventListener('DOMMouseScroll', handleScroll, false);
          canvas_el.removeEventListener('mousewheel', handleScroll, false);
        }
        if(planetContainer){
          planetContainer.removeChildren();
        }
        if(container){
          container.removeChildren();
        }
        window.removeEventListener("resize", onResize);
        PIXI.ticker.shared.remove(delta_resize);
        PIXI.ticker.shared.remove(update);
        eventManager.broadcast('destroy-c3-map');
        if(clear_cache){
          for(var texture in PIXI.TextureCache){
            var tmp = PIXI.Texture.removeTextureFromCache(texture);
            tmp.destroy(true);
          }
        }
        if(app){
          app.destroy(true);
        }

        // $log.log('destroy c3!')
      }

      scope.hasAgendaOption = function(){
        return scope.hasAgendas;
      }
      scope.hasModuleOption = function(){
        return true && scope.currentActiveSubModule && scope.currentActiveSubModule.children;
      }
      scope.isShowingAgendaPanel = function(){
        return scope.showAgenda;
      }
      scope.isShowingModulePanel = function(){
        return (!scope.showAgenda && !TeacherDataService.isTeacherWorkspaceView);
      }

      scope.hideModal = function(cycle){
        scope.modal3Hidden = true;
      }


      window.addEventListener("resize", onResize);

    //}, 500)

    }
  }
});

var PIXI_Load_Cache;
var EXISTS;
